import store, {toast} from '@/store'

import {apiAxios} from '@/router/auth'

export default {
  state: {
    manager_tickets_seguint: [],
    manager_groups_tickets: [],
    manager_groups_history_tickets: []
  },
  getters: {},
  actions: {
    fetchManagerGroupsTickets ({commit}) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/managers/${store.getters.getUser.id}/tickets`, {
          params: {
            all_grups: true
          }
        }).then(response => {
          commit('setManagerGroupsTickets', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    fetchManagerGroupsHistoryTickets ({commit}) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/managers/${store.getters.getUser.id}/tickets`, {
          params: {
            all_grups: true,
            history_tickets: true
          }
        }).then(response => {
          commit('setManagerGroupsHistoryTickets', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    managerFollowTicket (context, data) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Afegint gestors a la incidència...', () => new Promise((resolve, reject) => {
        apiAxios.post(`/managers/${data.ticketId}/follow`, data).then(response => {
          context.commit('setTicket', response.data)
          resolve(toast('Modificat', `Els gestors han estat afegits a la incidència correctament`))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'La incidència no s\'ha modificat correctament'))
        })
      }))
    },
    managerUnfollowTicket (context, data) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Eliminant gestors a la incidència...', () => new Promise((resolve, reject) => {
        apiAxios.delete(`/managers/${data.ticketId}/${data.codi_xarxa}/unfollow`).then(response => {
          context.commit('setTicket', response.data)
          resolve(toast('Modificat', `Els gestors han estat eliminats de la incidència correctament`))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'La incidència no s\'ha modificat correctament'))
        })
      }))
    },
    managerReassignTicket (context, data) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Reassignant incidència...', () => new Promise((resolve, reject) => {
        apiAxios.put(`/tickets/reassign/${data.ticket_id}`, data).then(response => {
          context.commit('setTicket', response.data)
          resolve(toast('Modificat', `Incidència amb id ${response.data.id} reassignada correctament`))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'La incidència no s\'ha reassignat correctament'))
        })
      }))
    },
    managerTransitionTicket (context, data) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Editant incidència...', () => new Promise((resolve, reject) => {
        apiAxios.put(`/tickets/manager/${data.ticket_id}`, data).then(response => {
          if (response.data.files) {
            context.dispatch('fetchTicketFiles', { ticketId: response.data.id, files: response.data.files })
          }
          context.commit('setTicket', response.data)
          resolve(toast('Modificat', `Incidència amb id ${response.data.id} modificat correctament`))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'La incidència no s\'ha modificat correctament'))
        })
      }))
    },
    managerSendEmail(context, data) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Enviant correu...', () => new Promise((resolve, reject) => {
        apiAxios.post(`/send_email/${data.ticket_id}`, data).then(response => {
          resolve(toast('Enviat', `Correu enviat correctament`))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'El correu no s\'ha enviat correctament'))
        })
      }))
    }
  },
  getters: {
    managerGroupsTickets: state => {
      return state.manager_groups_tickets
    },
    managerGroupsHistoryTickets: state => {
      return state.manager_groups_history_tickets
    },
  },
  mutations: {
    setManagerGroupsTickets (state, tickets) {
      state.manager_groups_tickets = tickets
    },
    setManagerGroupsHistoryTickets (state, tickets) {
      state.manager_groups_history_tickets = tickets
    },
    addTicket (state,  ticket) {
      state.manager_groups_tickets.push(ticket)
    }
  }
}
